import { render, staticRenderFns } from "./foldout-card.vue?vue&type=template&id=07c36265&scoped=true&"
import script from "./foldout-card.vue?vue&type=script&lang=ts&"
export * from "./foldout-card.vue?vue&type=script&lang=ts&"
import style0 from "./foldout-card.vue?vue&type=style&index=0&id=07c36265&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c36265",
  null
  
)

export default component.exports